import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'components/ReactRouterDomLocalized';
import queryString from 'query-string';

import Footer from '../../components/Footer';
import HeaderWallet from 'components/wallet/HeaderWallet';
import Pagination from 'components/Pagination';
import FooterWallet from 'components/wallet/FooterWallet';
import ProfileLink from 'components/ProfileLink';

import {getMemberWallet} from 'reducers/memberWallet';
import {formatDate, formatProduct} from 'utils/wallet';

const ITEMS_PER_PAGE = 10;

import {t, nt, dt} from 'l10n';

import 'sass/member/wallet/wallet.scss';
import 'sass/member/wallet/wallethistory.scss';

import paths from 'paths';
import ResponsiveList from "../../components/index/ResponsiveList";

class WalletHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            order: "desc",
            page: 1
        };

        this.sortFn = this.sortFn.bind(this);
    }

    componentDidMount() {
        if (!this.props.virtualGifts)
            this.props.getMemberWallet();

        this.updateStateFromLocation(this.props.location);
    }

    componentWillReceiveProps(nextProps) {
        this.updateStateFromLocation(nextProps.location);
    }

    updateStateFromLocation(location) {
        let {order, page} = queryString.parse(location.search);

        this.setState({
            order: ["asc", "desc"].indexOf(order) != -1 ? order : "desc",
            page: parseInt(page) || 1
        });
    }

    sortFn(a, b) {
        let isDesc = (this.state.order === "desc");

        return (!isDesc ? 1 : -1) * ( new Date(a.date).getTime()  - new Date(b.date).getTime() );
    }

    descProductUserTokens(item) {
        let creditMsg = nt('Token from ', 'Tokens from ', item.credit);
        let debitMsg = nt('Token for ', 'Tokens for ', item.debit);

        return (
        	<span>
        		{t(item.credit ? creditMsg : debitMsg)}
        		<ProfileLink user={item.product} __context={this.context}/>
        	</span>
        );
    }

    descProductGift(item) {

        return (
            <span>
        		{dt('xxl', 'Virtual gift for')}&ensp;
                <ProfileLink user={item.product.receiver} __context={this.context}/>
        	</span>
        );
    }

    descProductPpv(item) {
        if (!item.product) return null;
        let creditMsg = nt('Token from ', 'Tokens from ', item.credit);
        let debitMsg = dt('mybobtv', 'Connection to the Show of');

        return <span>
                { item.credit ? creditMsg : debitMsg }&ensp;
                <ProfileLink user={item.product.receiver} __context={this.context}/>
            </span>
    }

    render() {
        let {location, history} = this.props,
            {list, totals} = history;

        let {order, page} = this.state;

        let sortableClassnames = ['sortable'];
        sortableClassnames.push(order === 'desc' ? null : 'sort-asc');

        let displayedList = list.sort(this.sortFn).slice((page-1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);

        return (
            <div id="wrapper">
                <HeaderWallet location={location}/>{/* Let HeaderWallet update on location/locale change */}

                <div className="wallet-products">
                    <div className="content">
                        <div className="history">

                            <table>
                                <thead>
                                <tr>
                                    <th/>
                                    <th className={sortableClassnames.join(' ')}>
                                        <Link
                                            to={{pathname: paths.memberWalletHistory.path, search: queryString.stringify({order: order === 'desc' ? 'asc' : 'desc', page: page})}}>
                                            <span className="title">Date</span> <span className="icon"/>
                                        </Link>
                                    </th>
                                    <th>{dt('xxl', 'Credit')}</th>
                                    <th>{dt('xxl', 'Debit')}</th>
                                    <th>{dt('xxl', 'Description')}</th>
                                </tr>
                                </thead>

                                <tbody>
                                {displayedList.map((item, index) =>
                                    <tr key={index}>
                                        <td/>
                                        <td>{formatDate(item)}</td>
                                        <td>{item.credit || ''}</td>
                                        <td>{item.debit || ''}</td>
                                        <td>
                                            {item.product_type=='TIP_CHATROOM' && item.product ? this.descProductUserTokens(item) :
                                                (
                                                    item.product_type=='GIFT' && item.product && item.product.receiver ? this.descProductGift(item) :
                                                        formatProduct(item)
                                                )
                                            }

                                            {item.product_type=='PPV' && this.descProductPpv(item) }
                                        </td>
                                    </tr>
                                )}
                                </tbody>

                                <tfoot>
                                <tr>
                                    <td/>
                                    <td><b>{dt('xxl', 'Total')}</b></td>
                                    <td><b>{totals.credit}</b></td>
                                    <td><b>{totals.debit}</b></td>
                                    <td/>
                                </tr>
                                </tfoot>


                            </table>

                        </div>

                        <Pagination
                            totalCount={list.length}
                            itemsPerPage={ITEMS_PER_PAGE}
                            currentPage={page}
                            urlFn={(page) => ({pathname: paths.memberWalletHistory.path, search: queryString.stringify({order: order, page: page})})}
                        />

                        <FooterWallet/>
                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser,
        history: state.memberWallet.history
    }),({
        getMemberWallet: getMemberWallet
    })
)(WalletHistory)


// WEBPACK FOOTER //
// ./src/containers/member/WalletHistory.js